import { useQuery } from "@tanstack/react-query";
import { getLeanSubagents } from "../../../../api/entity/subagents";
import { sortByKey } from "../../../../utils";

type SubagentOption = {
  label: string;
  value: string;
  name: string;
  email: string;
  legal_title: string;
};

export function useSubagentOptionsForQuotation(source_entity: string) {
  const { data: subagents, isFetching: isSubagentsFetching } = useQuery({
    queryKey: ["subagents", source_entity],
    queryFn: () => getLeanSubagents(source_entity),
    refetchOnWindowFocus: false,
    enabled: source_entity.includes("___member"),
  });

  const subagentOptions: SubagentOption[] = [];

  if (subagents?.data?.results) {
    for (let i = 0; i < subagents.data.results.length; i++) {
      const sub = subagents.data.results[i];
      if (!sub) continue;

      let label = "";
      if (sub.name) {
        label += `${sub.name} - `;
      }
      if (sub.legal_title) {
        label += `${sub.legal_title} - `;
      }
      label += sub.email;

      subagentOptions.push({
        label,
        name: sub.name,
        value: `${sub.id}___subagent`,
        email: sub.email,
        legal_title: sub.legal_title,
      });
    }
    sortByKey(subagentOptions, "label");
  }

  return { subagentOptions, isFetching: isSubagentsFetching };
}
